import { RouterLink } from '@angular/router';
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

export interface HomeFaq {
  question: string;
  answer: string;
  icon: string;
}

/** Homepage FAQ content; also used to build FAQPage JSON-LD. */
export const HOME_FAQS: HomeFaq[] = [
  {
    question: 'How long does it take to set up MemberTrace?',
    answer: 'Creating your account takes a few minutes. Getting fully set up depends on your organization: importing your member list, configuring membership types and dues, and branding your portal. Our team can help with the import and with more complex setups.',
    icon: 'schedule'
  },
  {
    question: 'Can I import my existing member data?',
    answer: 'Yes! MemberTrace supports CSV imports and can integrate with many existing systems. We\'ll help you migrate your data seamlessly, ensuring no information is lost in the process.',
    icon: 'upload_file'
  },
  {
    question: 'Is my member data secure?',
    answer: 'MemberTrace runs on Amazon Web Services, member data is encrypted in transit over HTTPS and at rest, and the production database is backed up automatically every day. Card payments are processed by Stripe, so card numbers are not handled by MemberTrace forms. Our security page has the details.',
    icon: 'security'
  },
  {
    question: 'What if I need to customize fields or workflows?',
    answer: 'MemberTrace is highly customizable. Every plan includes custom fields, forms, and automated dues renewal reminders. The Growth plan adds a custom workflow builder for your own automations.',
    icon: 'settings'
  },
  {
    question: 'Do you offer training and support?',
    answer: 'Yes. Every plan includes email, chat, and phone support, plus a knowledge base, onboarding docs, and standard onboarding to get your team set up.',
    icon: 'support_agent'
  },
  {
    question: 'Can I cancel or change my plan anytime?',
    answer: 'Of course. You can upgrade, downgrade, or cancel your plan at any time with no penalties. We believe in transparent pricing and flexible terms that work for your organization.',
    icon: 'swap_horiz'
  },
  {
    question: 'How do members access MemberTrace on their phones?',
    answer: 'Members use your branding on the web or download the shared MemberTrace app (iOS and Android). One download gives them your organization in the app—plus any other MemberTrace communities they belong to—without you launching or maintaining a separate app for each society.',
    icon: 'smartphone'
  },
  {
    question: 'Can we get our own app in the App Store or Google Play?',
    answer: 'Yes. Most communities use the shared MemberTrace app with full org branding. If you need your own listing and white-glove delivery, we scope custom branded apps with Enterprise customers—contact us to explore fit, timeline, and investment.',
    icon: 'storefront'
  }
];

@Component({
  selector: 'app-faq-section',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatIconModule, MatButtonModule, RouterLink],
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss']
})
export class FaqSectionComponent {
  faqs = HOME_FAQS;
}
